import React from "react";
import { NavLink } from "react-router-dom";
import { Button } from "reactstrap";
import "./navbar.css";
import { FaUserAstronaut, FaWpforms } from 'react-icons/fa';
import {
  
    AiOutlineHome,
     
  } from "react-icons/ai";
function Navbar() {
  return (
      
      <div className="nav__header">
        
        <nav>
        
          <NavLink
            to="/port-folio"
            
            activeClassName="active__link"
            className="nav__links"
          >
          <AiOutlineHome/>  Home
          </NavLink>

           
          <NavLink
            to="/about"
            activeClassName="active__link"
            className="nav__links"
          >
            <FaUserAstronaut/> {"  "} About Me!
          </NavLink>
          <NavLink
            to="/projects"
            activeClassName="active__link"
            className="nav__links"
          >
           <FaWpforms/> {" "} Projects
          </NavLink>
        </nav>
        
    </div>
   
     
  );
}

export default Navbar;


// import React, { useState } from "react";
// import Navbar from "react-bootstrap/Navbar";
// import Nav from "react-bootstrap/Nav";
// import Container from "react-bootstrap/Container";
 
// import { Link } from "react-router-dom"; 
// import {
  
//   AiOutlineHome,
//   AiOutlineFundProjectionScreen,
//   AiOutlineUser,
// } from "react-icons/ai";

// import { CgFileDocument } from "react-icons/cg";

// function NavBar() {
//   const [expand, updateExpanded] = useState(false);
//   const [navColour, updateNavbar] = useState(false);

//   function scrollHandler() {
//     if (window.scrollY >= 20) {
//       updateNavbar(true);
//     } else {
//       updateNavbar(false);
//     }
//   }

//   window.addEventListener("scroll", scrollHandler);

//   return (
//     <Navbar
//       expanded={expand}
//       fixed="top"
//       expand="md"
//       className={navColour ? "sticky" : "navbar"}
//     >
//       <Container>
       
//         <Navbar.Toggle
//           aria-controls="responsive-navbar-nav"
//           onClick={() => {
//             updateExpanded(expand ? false : "expanded");
//           }}
//         >
//           <span></span>
//           <span></span>
//           <span></span>
//         </Navbar.Toggle>
//         <Navbar.Collapse id="responsive-navbar-nav">
//           <Nav className="ml-auto" defaultActiveKey="#home">
//             <Nav.Item>
//               <Nav.Link as={Link} to="/port-folio" onClick={() => updateExpanded(false)}>
//                 <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
//               </Nav.Link>
//             </Nav.Item>

//             <Nav.Item>
//               <Nav.Link
//                 as={Link}
//                 to="/about"
//                 onClick={() => updateExpanded(false)}
//               >
//                 <AiOutlineUser style={{ marginBottom: "2px" }} /> About
//               </Nav.Link>
//             </Nav.Item>

//             <Nav.Item>
//               <Nav.Link
//                 as={Link}
//                 to="/projects"
//                 onClick={() => updateExpanded(false)}
//               >
//                 <AiOutlineFundProjectionScreen
//                   style={{ marginBottom: "2px" }}
//                 />{" "}
//                 Projects
//               </Nav.Link>
//             </Nav.Item>

                    
//           </Nav>
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>
//   );
// }

// export default NavBar;
